<template>
    <div class="d-flex flex-1 h-100 overflow-hidden">
        <v-card class="report-container w-100 p-0" style="border-radius: 12px; margin-bottom: 24px">
            <v-toolbar class="shadow-none" style="flex: unset;" content-class="h-auto">
                <div class="custom-icon-wrapper">
                    <v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
                </div>
                <v-toolbar-title class="size-16 dark-text">{{ $t("res_Label_ManageMoveStructure") }}</v-toolbar-title>
            </v-toolbar>

            <div class="border-top p-4 flex-1 overflow-auto">
                <div class="row align-items-end m-0 gap-4">
                    <div class="col-3 p-0">
                        <v-label class="label_required mr-4 pt-2">{{ $t("res_Label_Structure") }}<span> *</span></v-label>
                        <StructureUserSelector  
                            :showInternalUsers="false" 
                            :showInternalStructures="true"
                            :showExternalStructures="false" 
                            :excludeSelf="false"
                            :isMultiple="false" 
                            :addressBook_header="$t('res_Label_SelectStructure')"
                            :selectedStructureUser="fromStructureQuery" @structureUserSelectChanged="selectfromStructureQuery"
                            :isSubscribedEntitiesEnable="this.constants.client_version_Id == 'DEG' && true">
                        </StructureUserSelector>
                    </div>
                    <div class="col-3 p-0">
                        <v-label class="label_required mr-4 pt-2">{{ $t("res_Label_TransferStatus") }}<span></span></v-label>
                        <v-select solo v-model="transferStatusId" :items="transferStatuses" item-text="text" item-value="value"></v-select>
                    </div>
                </div>
                <hr>
                <div class="d-flex gap-2 my-4">
                    <v-btn :disabled="!this.fromStructureIdVal" class="primary d-flex align-center"
                        @click="getAllOpenedTransferForStructure(0)" color="primary">{{ $t("res_ButtonText_Search") }}</v-btn>   
                    <v-btn :disabled="selectedTransfers.length == 0" class="primary d-flex align-center"
                        @click="openAddToStructureDialog" >
                        {{ $t("res_ButtonText_Move") }} 
                    </v-btn>    
                    <v-btn @click="openMoveToStructureDialog(2)" :disabled="all_transfers == null || all_transfers.length == 0" class="primary d-flex align-center">
                        {{ $t("res_ButtonText_MoveAll") }} 
                    </v-btn>
                </div>

                <Pagination class="mb-2" :totalCount="pagingData.totalCount" :pageSize="pagingData.pageSize"
                    :pageIndex="pagingData.pageIndex" @pageIndexChanged="pageIndexChanged"
                    :showPageSize="true" :showMargin="false"></Pagination>
                   
                <v-data-table id="ListCorrespondancesTable" class="elevation-1 mt-3" :mobile-breakpoint="0" :headers="headers" 
                    :items="all_transfers" disable-sort hide-default-footer show-select @input="itemSelected" :items-per-page="pagingData.pageSize">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>
                                <v-checkbox v-model="selectedTransfers" :value="item"></v-checkbox>
                            </td>
                            <td>{{ item.id }}</td>
                            <td>{{ item.referenceNumber }}</td>
                            <td>{{ item.subject }}</td>
                            <td>{{ item.fromStructure }}</td> 
                            <td>{{ item.status }}</td>
                            <td>{{ item.transferPurpose }}</td>
                            <td>{{ utils.formatDateTimeWithTime(item.transferDate) }}</td>
                        </tr>
                    </template>

                    <template v-slot:no-data>
                        <v-row class="p-5">
                            <img style="width: 118px" src="/assets/images/empty-inbox.svg" alt="" />
                            <p class="m-0">{{ $t("res_Msgs_AlertNoItemsHere") }}</p>
                        </v-row>
                    </template>
                </v-data-table>   
                    
                <div class="container row" v-if="all_transfers != null && all_transfers.length > 0">
                    <v-btn class="btn-sm" color="white" @click="getAllOpenedTransferForStructure(1)" v-tooltip="$t('res_Export_To_Excel')">
                        <v-icon class="bg-gray black--text custom-button" style="color: #388729 !important; background-image: none;">mdi-file-excel</v-icon>
                    </v-btn>
                    <v-btn class="btn-sm" color="white" @click="getAllOpenedTransferForStructure(2)" v-tooltip="$t('res_Export_To_Pdf')">
                        <v-icon class="bg-gray custom-button">mdi-file-pdf-box</v-icon>
                    </v-btn> 
                </div>
            </div>
        </v-card>

        <v-dialog v-model="AddToStructureDialog" content-class="dialog with-fixed-actions bg-white w-40 right" fullscreen width="70%" scrollable>
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">{{ $t("res_DialogTitle_Transfer") }}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="AddToStructureDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <div class="d-flex flex-column flex-1">
                    <div class="p-4 flex-1 overflow-auto">
                        <v-banner single-line @click:icon="alert" outlined style="background-color: #f9f9f9; margin-bottom: 1vw;">
                            <v-icon slot="icon" color="warning" size="30">mdi-alert</v-icon>
                            <span style="font-size: 1rem;" v-if="selectedLang == 'en'">This will move selected ({{ selectedTransfers.length }}) documents to the selected structure.</span>
                            <span style="font-size: 1rem;" v-else>سيتم نقل الوثائق المحددة ({{ selectedTransfers.length }}) إلى الهيكل المحدد.</span>
                        </v-banner>
                        <div class="mb-3-rem">
                            <v-label class="label_required mb-2">{{ $t("res_Label_SelectStructureOrUser") }}<span> *</span></v-label>
                            <StructureUserSelector 
                                :showInternalUsers="true" :showInternalStructures="true"
                                :showExternalStructures="false" :excludeSelf="false" :isMultiple="false"
                                :selectedStructureUser="ToStructureValQuery" @structureUserSelectChanged="selectToStructureValQuery">
                            </StructureUserSelector>
                        </div>
                    </div>
                    <v-card-actions class="top-shadow gap-3">
                        <v-btn class="light-blue flex-1" @click="AddToStructureDialog = false">{{$t("res_ButtonText_Cancel")}}</v-btn>
                        <v-btn class="primary flex-1" @click="setUpMoveStrucrureTransfersDialog">{{$t("res_ButtonText_Save")}}</v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="moveToStructureDialog" content-class="dialog with-fixed-actions bg-white w-40 right" fullscreen width="70%" scrollable>
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">{{ $t("res_DialogTitle_MoveToStructure") }}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="moveToStructureDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <div class="d-flex flex-column flex-1">
                     <v-banner v-if="moveActionType == 2" single-line @click:icon="alert" outlined style="background-color: #f9f9f9; margin-bottom: 1vw;">
                        <v-icon slot="icon" color="warning" size="30">mdi-alert</v-icon>
                        <span style="font-size: 1rem;" v-if="selectedLang == 'en'">This will move all ({{ pagingData.totalCount }}) documents to the selected structure.</span>
                        <span style="font-size: 1rem;" v-else>هذا سينقل جميع الوثائق ({{ pagingData.totalCount }}) إلى الهيكل المحدد.</span>
                    </v-banner>
                    <div class="p-4 flex-1 overflow-auto">
                        <div class="mb-3-rem">
                            <v-label class="label_required mb-2">{{ $t("res_Label_SelectStructureOrUser") }}<span> *</span></v-label>
                            <StructureUserSelector :showInternalUsers="true" :showInternalStructures="true"
                                :showExternalStructures="false" :excludeSelf="false" :isMultiple="false"
                                :selectedStructureUser="toStructureQuery" @structureUserSelectChanged="selectToStructureQuery">
                            </StructureUserSelector>
                        </div>
                    </div>
                    <v-card-actions class="top-shadow gap-3">
                        <v-btn class="light-blue flex-1" @click="moveToStructureDialog = false">{{$t("res_ButtonText_Cancel")}}</v-btn>
                        <v-btn class="primary flex-1" @click="setUpMoveLettersToStructureDialog">{{$t("res_ButtonText_Save")}}</v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="informationDialogOptions.visible" content-class="small-dialog" width="20%">
            <v-card>
                <v-card-title>{{ informationDialogOptions.title }}</v-card-title>
                <div class="bg-white">
                    <div class="card-body">
                        <p class="mb-0">{{ informationDialogOptions.text }}</p>
                    </div>
                    <v-card-actions class="gap-2 sticky-actions">
                        <v-spacer></v-spacer>
                        <v-btn color="light-blue" @click="informationDialogOptions.visible = false">{{ $t('Cancel')}}</v-btn>
                        <v-btn 
                        @click="informationDialogOptions.confirmFunction(); informationDialogOptions.visible = false;"
                        color="primary">{{ $t('Confirm')}}</v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios';
import constants from '@/assets/js/constants';
import * as utils from '@/assets/js/common.js';
import StructureUserSelector from '@/components/StructureUserSelector.vue';
import Pagination from '@/components/Pagination.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
    name: 'ManageMoveStructure',
    components: {
        StructureUserSelector,
        Pagination,
        ConfirmDialog
    },
    data() {
        return { 
            constants: constants,
            transferStatusId: 0,  
            transferStatuses: 
            [
                { text: this.$t('res_CardHeaders_All'), value: 0 },
                { text: this.$t('res_Label_InProgress'), value: 1 },
                { text: this.$t('res_Label_Closed') , value: 2 },
                { text: this.$t('res_Label_Archived') , value: 3 }
            ],
            informationDialogOptions: {
                title: '',
                text: '',
                confirmFunction: null,
                cancelFunction: null,
                visible: false
            },
            utils: utils,
            AddToStructureDialog: false,
            moveToStructureDialog: false,
            isMoveBtnDisabled: true,
            isMoveWithLettersBtnDisabled: true,
            fromStructureQuery: null,
            ToStructureValQuery: null,
            toStructureQuery: null,
            fromStructureIdVal: null,
            fromStructureId: null,
            ToStructureIdVal: null,
            toStructureId: null,
            all_transfers: [],
            headers: [
                { text: '', value: 'data-table-select' },
                { text: this.$t("res_GridHeaders_Id"), value: 'id' },
                { text: this.$t("res_MenuItems_ReferenceNumber"), value: 'referenceNumber'},
                { text: this.$t("res_GridHeaders_Subject"), value: 'subject'},
                { text: this.$t("res_GridHeaders_FromStructure"), value: 'fromStructure' }, 
                { text: this.$t("res_Label_DocumentStatus"), value: 'statusId' },
                { text: this.$t("res_GridHeader_TransferPurpose"), value: 'transferPurpose' },
                { text: this.$t("res_GridHeader_TransferDate"), value: 'transferDate' },
            ],
            pagingData: {
                pageSize: 10,
                pageIndex: 0,
                totalCount: 0
            },
            selectedTransfers: [],
            moveActionType: 0,
            selectedLang: 'en'
        }
    },
    methods: {
        backToAdminPage() {
            this.$router.push('/admin');
        },
        openMoveToStructureDialog(type) {
            this.moveToStructureDialog = true;
            this.moveActionType = type;
        },
        selectfromStructureQuery(item) {
            this.fromStructureQuery = item ?? null;
            this.fromStructureIdVal = item?.id?.toString() ?? null;
        },
        selectToStructureValQuery(item) 
        {
            this.ToStructureValQuery = item ?? null;
            this.ToStructureIdVal = item?.id?.toString() ?? null;
        },
        selectToStructureQuery(item) {
            if (item == null) {
                this.toStructureQuery = null;
                this.toStructureId = null;
                return;
            }
            this.toStructureQuery = item;
            var stringId = item.id.toString();
            this.toStructureId = stringId.split('-')[0];
            if(this.fromStructureId == this.toStructureId)
            {
                window.showAlert('res_Msgs_SameStructureSelected', 'warning');
                this.toStructureQuery = null;
                this.toStructureId = null;
            }
        },
        pageIndexChanged(pagingData) {
            this.pagingData.pageSize = pagingData.pageSize;
            this.pagingData.pageIndex = pagingData.pageIndex;
            this.getAllOpenedTransferForStructure(0);
        },
        itemSelected(item) {
            this.selectedTransfers = item;
        },
        openAddToStructureDialog() {
            this.AddToStructureDialog = true;
        },
        async getAllOpenedTransferForStructure(exportType) {
            try {
                if(!this.fromStructureIdVal)
                {
                    window.showAlert("res_Msgs_NoSelectedStructure", 'warning');
                    return;
                }
                let extension = exportType == 1 ? '.xlsx' : '.pdf';
                if(exportType==0){
                    this.all_transfers = [];
                    this.selectedTransfers = [];
                }
                window.showLoading(); 
                if(exportType==0){
                    const response = await axios.get(constants.baseApiUrl + 'Admin/GetAllOpenedTransfersForStructure?structureId=' + this.fromStructureIdVal + '&pageSize=' + this.pagingData.pageSize + '&pageIndex=' + this.pagingData.pageIndex+"&exportType="+exportType + '&transferStatusId=' + this.transferStatusId);
                    this.all_transfers = response.data.transfers;
                    this.pagingData.totalCount = response.data.totalRecords;
                    this.isMoveBtnDisabled = this.all_transfers.length != 0 || !this.fromStructureIdVal;
                    this.isMoveWithLettersBtnDisabled = this.all_transfers.length == 0 || !this.fromStructureIdVal;
                }
                else{
                    axios({
                        url: constants.baseApiUrl + 'Admin/GetAllOpenedTransfersForStructure?structureId=' + this.fromStructureIdVal + '&pageSize=' + this.pagingData.pageSize + '&pageIndex=' + this.pagingData.pageIndex+"&exportType="+exportType + '&transferStatusId=' + this.transferStatusId,
                        method: 'GET',
                        responseType: 'blob',
                    })
                    .then((res) => {
                    var blob = new Blob([res.data], { type: "application/octetstream" });
                        const link = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.setAttribute("download", "ExportedData" + `${extension}`);
                        a.setAttribute("href", link);
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    })
                }

            } catch (error) {
                console.log(error);
            }
            finally {
                window.hideLoading();
            }
        }, 
        setUpMoveStrucrureTransfersDialog() 
        {
            if (!this.ToStructureIdVal)
            {
                window.showAlert('res_Msgs_SelectUserToTransferWarning', 'warning');
                return;
            }

            this.informationDialogOptions.title = this.$t('res_Msgs_Confirmation');
            this.informationDialogOptions.text = this.$t('res_Msgs_confirm_basic');
            this.informationDialogOptions.confirmFunction = this.moveSelectedTransfers;
            this.informationDialogOptions.visible = true;
        },
        async moveSelectedTransfers() 
        {
            try 
            {
                window.showLoading();
                const postObj = {
                    TransferIds: this.selectedTransfers.map(x => x.id),
                    ToStructureUserId: this.ToStructureIdVal,
                    OriginalStructureId: parseInt(this.fromStructureIdVal),
                    TransferStatusId: this.transferStatusId
                };
                const response = await axios.post(constants.baseApiUrl + 'Admin/MoveSelectedTransfersToNewStructures', postObj);
                window.hideLoading();
                if (response.data)
                { 
                    await this.getAllOpenedTransferForStructure(0); 
                    window.showAlert('res_Msgs_MoveSelectedletters', 'success');
                    this.AddToStructureDialog = false;
                }
                else
                    window.showAlert('res_Msgs_failed_basic', 'error');
            } 
            catch (error) 
            {
                console.log(error);
            }
            finally 
            {
                this.selectedTransfers = [];
            }
        },
        setUpMoveLettersToStructureDialog() 
        {
            this.informationDialogOptions.title = this.$t('res_Msgs_Confirmation');
            this.informationDialogOptions.text = this.$t('res_Msgs_confirm_basic');
            this.informationDialogOptions.confirmFunction =  this.moveLettersToStructure;
            this.informationDialogOptions.visible = true;
        },
        resetInputs() 
        {
            this.fromStructureQuery = null;
            this.fromStructureIdVal = null;
            // this.fromStructureId = 0;
            this.ToStructureValQuery = null;
            this.ToStructureIdVal = null;
            this.toStructureQuery = null;
            this.toStructureId = null;
            this.isMoveBtnDisabled = true;
            this.isMoveWithLettersBtnDisabled = true;
        }, 
        async moveLettersToStructure() 
        {
            try 
            { 
                if (!this.toStructureId || !this.fromStructureIdVal)
                {
                    window.showAlert('res_Msgs_SelectStructureToMoveWarning', 'warning');
                    return;
                }

                window.showLoading();
                const postObj = {
                    TransferIds: this.all_transfers.map(x => x.id),
                    ToStructureUserId: this.toStructureId,
                    OriginalStructureId: parseInt(this.fromStructureIdVal),
                    TransferStatusId: this.transferStatusId
                };

                const response = await axios.post(constants.baseApiUrl + 'Admin/MoveSelectedTransfersToNewStructures', postObj); 
                if (response.data > 0)
                {
                    window.showAlert('res_Msgs_MoveSelectedletters', 'success');
                    this.moveToStructureDialog = false;
                    this.all_transfers = [];  
                    this.resetInputs();
                }
                else 
                {
                    window.showAlert('res_Msgs_failed_basic', 'error');
                }    
            } 
            catch (error) 
            {
                console.log(error);
            }
            finally 
            {
                window.hideLoading();
            }
        }
    },
    mounted() 
    {
        this.selectedLang = localStorage.getItem('lang')
    }
}

</script>

<style scoped>
#ListCorrespondancesTable table thead th.text-start  {
    background: var(--table-header-color);
    padding-left: 8px !important;
    padding-right: 8px !important;
}

.report-container {
    height: calc(100vh - 116px);
    display: flex;
    flex-direction: column;
    border-radius: 12px !important;
    margin-left: 1rem;
    overflow: auto;
    box-shadow: none !important;
}
</style>